import React from 'react';

import { Grid, List, Stack } from '@mui/material';

import RandomImg from '../Assets/Random/random3.png';

import CustomListItem2 from './CustomListItem2';
import { TypoPoppBlue } from './Typo';

const FooterGetToKnow = () => {
  return (
    <Grid
      container
      columns={{ xs: 1, md: 2 }}
      alignItems='center'
      rowSpacing={{ xs: 2, md: 'unset' }}
    >
      <Grid item xs={1} alignSelf='stretch'>
        <img
          src={RandomImg}
          alt=''
          style={{
            minWidth: '0',
            height: '100%',
            width: '100%',
            objectFit: 'cover',
          }}
        />
      </Grid>

      <Grid item xs={1}>
        <Stack
          width='fit-content'
          mx='auto'
          gap={3}
          padding={{ xs: 3, md: 'unset' }}
        >
          <TypoPoppBlue fontWeight={600} variant='h5'>
            Get to know your Customers
          </TypoPoppBlue>
          <List
            sx={{
              ' > *:not(:last-child)': {
                mb: 2,
              },
            }}
          >
            <CustomListItem2 index='1'>
              No matter where they’re from, our customers are verified.
            </CustomListItem2>
            <CustomListItem2 index='2'>
              You can get to know your customers transparently.
            </CustomListItem2>
          </List>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default React.memo(FooterGetToKnow);
